<template>
  <div id="basic-layout">
    <Suspense>
      <main>
        <router-view v-slot="{ Component, route }">
          <transition mode="out-in" name="fade">
            <div id="page" :key="route.name">
              <component :is="Component" :id="route.name" />
            </div>
          </transition>
        </router-view>
      </main>
    </Suspense>
  </div>
</template>


<script setup lang="ts">
</script>

<style lang="scss" scoped>
#basic-layout {
  main {
    width: 100%;
    height: 100%;
    padding: 0;
  }

  #page {
    width: 100%;
    height: 100%;
    padding: 0;
  }
}
</style>